// Nothing filters bots server-side, and an unrecognised device type is recorded as a
// desktop human, so a crawler would otherwise be counted as a customer.
// `bot` is matched only where crawlers actually put it — Googlebot/2.1, DuckDuckBot-Https —
// because a bare /bot/ also matches the CUBOT range of Android phones and would silently
// drop those shoppers for good.
const BOT_PATTERN =
    /bot[/;)-]|bot$|crawl|spider|slurp|headless|lighthouse|pagespeed|gtmetrix|phantom|puppeteer|playwright/i;

/** True for automated clients that should not be counted as visitors. */
export function isBotUserAgent(userAgent) {
    return BOT_PATTERN.test(String(userAgent || ''));
}
